module.exports = __webpack_public_path__ + "img/form_checklist.3884e4db.svg";